import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UniqueEntityID } from '@digibricks/core';
import { SingleChoiceCorrectAnswer } from '../correct-answers';
import { Answer } from '../answer';
import { QuestionType } from '../question-type';
import { QuestionRelease } from './question-release';
import { SingleChoiceQuestion } from '../questions';
export var SingleChoiceQuestionRelease = /*#__PURE__*/function (_QuestionRelease) {
  _inherits(SingleChoiceQuestionRelease, _QuestionRelease);

  var _super = _createSuper(SingleChoiceQuestionRelease);

  function SingleChoiceQuestionRelease() {
    _classCallCheck(this, SingleChoiceQuestionRelease);

    return _super.apply(this, arguments);
  }

  _createClass(SingleChoiceQuestionRelease, [{
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "correctAnswers",
    get: function get() {
      return this.props.correctAnswers;
    }
  }, {
    key: "isCorrect",
    value: function isCorrect(answerId) {
      if (!answerId) {
        return false;
      }

      if (this.correctAnswers.length === 0) {
        return false;
      }

      return this.correctAnswers[0].answerId === answerId;
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps, hasCorrectAnswer) {
      var props = _objectSpread(_objectSpread({}, newQuestionProps), {}, {
        answers: this.props.answers,
        correctAnswers: hasCorrectAnswer ? this.props.correctAnswers : []
      });

      return SingleChoiceQuestionRelease.create(props);
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(SingleChoiceQuestionRelease.prototype), "toJsonObject", this).call(this)), {}, {
        answers: this.props.answers.map(function (answer) {
          return answer.toJsonObject();
        }),
        correctAnswers: this.props.correctAnswers.map(function (correctAnswer) {
          return correctAnswer.toJsonObject();
        })
      });
    }
  }, {
    key: "convertToQuestion",
    value: function convertToQuestion() {
      var baseProps = _get(_getPrototypeOf(SingleChoiceQuestionRelease.prototype), "convertToQuestionProps", this).call(this);

      var questionOrError = SingleChoiceQuestion.create(_objectSpread(_objectSpread({}, baseProps), {}, {
        answers: this.props.answers,
        correctAnswers: this.props.correctAnswers
      }));
      return questionOrError.getValue();
    }
  }, {
    key: "updateAnswers",
    value: function updateAnswers(answers) {
      this.props.answers = answers;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var basePropsOrError = _get(_getPrototypeOf(SingleChoiceQuestionRelease), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), props), {}, {
        type: QuestionType.SingleChoice
      });

      return Result.ok(new SingleChoiceQuestionRelease(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answers = data.answers,
            correctAnswers = data.correctAnswers;

        var basePropsOrError = _get(_getPrototypeOf(SingleChoiceQuestionRelease), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var answerResultCombine = answers.map(function (a) {
          return Answer.fromJson(a);
        });
        var answerPropsOrError = Result.combineArray(answerResultCombine);

        if (answerPropsOrError.isFailure) {
          return Result.fail(answerPropsOrError.error);
        }

        var correctAnswerProps = correctAnswers ? correctAnswers.map(function (c) {
          return SingleChoiceCorrectAnswer.create({
            id: c.id,
            answerId: c.answerId
          }).getValue();
        }) : [];
        var question = this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          answers: answerPropsOrError.getValue(),
          correctAnswers: correctAnswerProps,
          type: QuestionType.SingleChoice
        }));
        return question;
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return SingleChoiceQuestionRelease;
}(QuestionRelease);